import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, pipe } from 'rxjs';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginUserUseCase } from 'src/app/core/usecases/AuthUser/LoginUserUseCase';
import { User } from '../_model/User';
import { UserRequestDTO } from 'src/app/data/dto/UserDTO';
 
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
private currentUserSubject: BehaviorSubject<User>;
public currentUser: Observable<User>;

constructor(private http: HttpClient, private loginUserUseCase: LoginUserUseCase) {
this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
this.currentUser = this.currentUserSubject.asObservable();
}
 
public get currentUserValue(): User {
return this.currentUserSubject.value;
}
 
public async login(email: string, password: string): Promise<Observable<User>>{    
    const userrequest: UserRequestDTO = {
          email: email,
          password: password
        };        
   const data = await this.loginUserUseCase.execute(userrequest).toPromise();
   if(data && data.email == email){
    let user = new User();
    user.id = data.id;
    user.email = data.email;
    user.firstName = data.firstName;
    user.lastName = data.lastName;
    user.phone = data.phone;    
    user.mailto = data.mailto;        
    localStorage.setItem('currentUser', JSON.stringify(user));

    localStorage.removeItem('tidioPerson');
    let tidioPersonEmail = user.firstName + ' ' + user.lastName;
    localStorage.setItem('tidioPerson', tidioPersonEmail);

    this.currentUserSubject.next(user); 
    console.log(this.currentUser);  
    return this.currentUser;
   }else{
    let nuser: User;      
    return of(nuser);
   }     
}
 
logout() {
// remove user data from local storage for log out
localStorage.removeItem('currentUser');
this.currentUserSubject.next(null);
}
}